import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { isEmpty, map } from 'lodash';
import classnames from 'classnames';
import { wrapGrid } from 'animate-css-grid';
import PropTypes from 'prop-types';
// import { analytics } from 'common/utils';
import * as css from './Category.scss';
import * as SelectCss from './SelectSongs.scss';

function SelectSongs(props) {
	const breakpoints = {
		tablet: 1024,
	};

	const [state, setState] = useState({
		cardHidden: [],
		cardDelete: [],
		state: null,
		toggleDrawer: false,
	});

	const [stateSong, setStateSong] = useState({
		dataSongsId: props.dataSongsId,
		items: props.items,
	});

	const [stateShowAnimation, setStateShowAnimation] = useState({
		showAnimation: false,
	});

	const [statePlay, setStatePlay] = useState({
		isPlaying: null,
	});

	const [size, setSize] = useState(0);

	const [stateDrag] = useState({
		activeDrags: 0,
		deltaPosition: {
			x: 0,
			y: 0,
		},
		controlledPosition: {
			x: 0,
			y: 0,
		},
	});

	const wrapRef = useRef(null);
	const wrapGridConfig = { easing: 'backOut', duration: 550 };
	const gridLeft = useRef(null);
	const gridRight = useRef(null);
	const panelContent = useRef(null);

	useLayoutEffect(() => {
		function updateSize() {
			setSize(window.innerWidth);
		}
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);

	useEffect(() => {
		wrapGrid(gridLeft.current, wrapGridConfig);
		wrapGrid(gridRight.current, wrapGridConfig);

		return () => {
			document.body.classList.remove('not-scroll');
		};
	}, []);

	useEffect(() => {
		if (!state.toggleDrawer) {
			setStateSong({ dataSongsId: props.dataSongsId, items: props.items });
		}

		setState({ ...state, cardDelete: [] });
		if (isEmpty(props.dataSongsId)) {
			setState({ ...state, cardDelete: [], toggleDrawer: false });
		}
		setStateShowAnimation({
			showAnimation: !isEmpty(props.dataSongsId),
		});

		if (props.openSongPopup) {
			toggleDrawer();
		}
	}, [props]);

	const listSong = () => {
		const { dataSongsId, items } = stateSong;
		if (!isEmpty(dataSongsId)) {
			return size > breakpoints.tablet ? items : [[...items[0], ...items[1]], []];
		}
		return [];
	};

	const onPlayClick = data => {
		const { id } = data;
		// const { songName, categoryId, id } = data;
		const isPlaying = statePlay.isPlaying === id ? null : id;

		// if (isPlaying) {
		// 	analytics.onPlaySnong(categoryId, songName);
		// }

		props.onPlayClick(id);
		setStatePlay({ isPlaying });
	};

	const responsiveArray = id => {
		return [stateSong.items[0].filter(item => item.id !== id), stateSong.items[1].filter(item => item.id !== id)];
	};

	const removeCard = id => {
		setStateSong({
			dataSongsId: props.dataSongsId.filter(item => item !== id),
			items: responsiveArray(id),
		});
		setState({ ...state, cardHidden: [...state.cardHidden, id] });
		setTimeout(() => {
			setState({ ...state, cardDelete: [...state.cardDelete, id], id });
			props.removeItemForList(id);
		}, 300);

		if (isEmpty(responsiveArray(id)[0]) && isEmpty(responsiveArray(id)[1])) {
			toggleDrawer();
		}
	};

	const dynamicItemClass = (type, classes, id) => (state[type].find(c => c === id) ? classes : '');

	const elementForList = (data, key) => {
		if (!data) {
			return null;
		}
		const { isSelected, subtitle, title, id } = data;

		return (
			<div
				key={id}
				className={classnames(
					css.item,
					{ [css.selected]: isSelected },
					SelectCss.itemSelect,
					SelectCss.card,
					`card--${key}`,
					`${dynamicItemClass('cardHidden', SelectCss.cardHidden, id)}`,
					`${dynamicItemClass('cardDelete', SelectCss.cardDelete, id)}`
				)}
			>
				<div>
					<div className={classnames(css.itemContent, SelectCss.itemContent)}>
						<div className={SelectCss.close} onClick={() => removeCard(id)}></div>
						<div className={SelectCss.itemTitle} title={title}>
							{title}
						</div>
						<div className={SelectCss.itemSubtitle} title={subtitle}>
							{subtitle}
						</div>
					</div>
					<div className={css.itemPlay} onClick={() => onPlayClick(data)}>
						<div className={classnames(css.itemPlayIcon, { [css.playing]: statePlay.isPlaying === id })}>
							<div className={css.itemPlayIconBars}>
								<div className={css.itemPlayIconBar} />
								<div className={css.itemPlayIconBar} />
								<div className={css.itemPlayIconBar} />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	const toggleDrawer = () => {
		// analytics.onMySongsBtnClick();
		if (state.toggleDrawer) {
			document.body.classList.remove('not-scroll');
		} else {
			document.body.classList.add('not-scroll');
		}
		if (stateDrag.controlledPosition.y === 0) {
			setState({ ...state, toggleDrawer: !state.toggleDrawer });
			props.openSongPopupHandler();
		}
		// props.onToggleDrawer(!state.toggleDrawer);
	};

	const gridSong = (count, turn) => {
		return (
			<div className={classnames(SelectCss.grid, SelectCss.gridTemplateColumns, 'grid')} ref={turn}>
				{map(listSong()[count], (item, key) => elementForList(item, key))}
			</div>
		);
	};

	return (
		<div
			className={classnames(
				SelectCss.wrapModal,
				state.toggleDrawer ? SelectCss.open : '',
				props.dataSongsId.length ? '' : SelectCss.hide
			)}
			ref={wrapRef}
		>
			<div className={SelectCss.overSelectSong} onClick={() => toggleDrawer()}></div>
			<div className={SelectCss.wrapDragPopup}>
				<div className={classnames(SelectCss.wrapSelect, 'no-cursor')}>
					<div className={classnames(SelectCss.wrapSelectListSong)}>
						<strong
							className={classnames(
								SelectCss.title,
								stateShowAnimation.showAnimation ? SelectCss.showAnimation : '',
								'cursor'
							)}
							onClick={toggleDrawer}
						>
							<i></i>
							<p>הבחירות שלי</p>
						</strong>

						<div className={classnames(SelectCss.selectSongContent)}>
							<div className={SelectCss.selectSongScroll}>
								<div className={SelectCss.panelContentCustom} ref={panelContent}>
									{gridSong(0, gridLeft)}
									{gridSong(1, gridRight)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <div className={SelectCss.fakeClickBlock} onClick={toggleDrawer}></div> */}
		</div>
	);
}

SelectSongs.propTypes = {
	openSongPopup: PropTypes.bool.isRequired,
	items: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
	dataSongsId: PropTypes.arrayOf(PropTypes.string).isRequired,
	onPlayClick: PropTypes.func.isRequired,
	openSongPopupHandler: PropTypes.func.isRequired,
	removeItemForList: PropTypes.func.isRequired,
	// onToggleDrawer: PropTypes.func.isRequired,
};

export default SelectSongs;
